import React from 'react';
import moment from 'moment';
import { connect } from "react-redux";

import getDateFormat from "../../utils/DateFormatRetriever";

//import SpotlioIcon from '../Icon';
import Steps from './steps';

import './index.scss';
import PushHistory from '../../utils/PushHistory';

const MobileMessage = (props) => {

    const {
        toggleButton,
        currentStep,
        pastSteps = [],
        arrivalDate,
        departureDate,
        guests,
        mode,
        isBackButton,
        form,
        message,
        returnToList = false
    } = props;

    const buttonMessage = () => {
        if (message) return message;
        if (isBackButton || returnToList ) return "Return to list";
        return "Edit search";
    }

    return (
        <div onClick={() => returnToList ? PushHistory("/products/lodging") : toggleButton(true)} className="mobileSearchArea">
            <div className="mobileMessage">
                <Steps steps={pastSteps} status="past" />
                <Steps steps={currentStep} status="current" />
            <div className="mobileSearchValues">
                {
                    mode === "lodging" &&
                    <>
                        <div className="value">
                            {moment.utc(arrivalDate || form.lodging.arrivalDate).format("DD MMM")} - {moment.utc(departureDate || form.lodging.departureDate).format("DD MMM")}
                        </div>
                        <div className="value">
                            {guests || form.lodging.guests || "0"} Guests
                        </div>
                    </>
                }
                {
                    mode === "activities" && arrivalDate && 
                    <div className="value">
                        {moment.utc(arrivalDate || form.activities.arrivalDate).format(getDateFormat("display"))}
                    </div>
                }
                {
                    (mode === "carrental" || mode === "packages") &&
                    <div className="value">
                        {moment.utc(arrivalDate).format("DD MMM")} - {moment.utc(departureDate).format("DD MMM")}
                    </div>
                }
            </div>
            </div>
            <div className="mobileSearchButton" >
                {buttonMessage()}
            </div>
        </div>
    )
}


function mapStateToProps(state) {
    return { form: state.form.form }
}

export default connect(mapStateToProps)(MobileMessage)
